import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import type { PaymentFrequency } from '@/hooks/finance/usePaymentAgreements';

interface FrequencySelectProps {
  value: PaymentFrequency;
  onChange: (value: PaymentFrequency) => void;
  disabled?: boolean;
}

const FREQUENCY_OPTIONS: { value: PaymentFrequency; label: string }[] = [
  { value: 'weekly', label: 'Semanal (7 dias)' },
  { value: 'biweekly', label: 'Quinzenal (15 dias)' },
  { value: 'monthly', label: 'Mensal (1 mês)' },
];

export function FrequencySelect({ value, onChange, disabled }: FrequencySelectProps) {
  return (
    <Select value={value} onValueChange={onChange} disabled={disabled}>
      <SelectTrigger className="w-full">
        <SelectValue placeholder="Selecione a frequência" />
      </SelectTrigger>
      <SelectContent>
        {FREQUENCY_OPTIONS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
